<script lang="ts">
	import { Dropdown, DropdownItem, type SelectOptionType } from "flowbite-svelte";
	import { twMerge } from "tailwind-merge";
	import P from "#lib/components/P.svelte";
	import Button from "#lib/ui/Button/index.js";
	import type { Placement } from "@floating-ui/dom";

	interface Props {
		items: SelectOptionType<ItemValue>[];
		dropdownKey: string;
		value: ItemValue;
		placement?: Placement;
		class?: string;
		handleChange: (e: MouseEvent) => void;
	}

	type ItemValue = string | number | string[] | null | undefined;

	let { items, handleChange, dropdownKey, value, placement = "bottom", class: className }: Props = $props();
	let dropdownOpen = $state(false);

	function handleClick(e: MouseEvent) {
		handleChange(e);
		dropdownOpen = false;
	}
</script>

<Button size="sm" class={twMerge("h-10 max-w-65 bg-gray-50 p-4", className)} color="light" data-action-name={dropdownKey} aria-haspopup="true" aria-expanded={dropdownOpen} aria-controls={dropdownKey}>
	<P class="truncate text-sm font-medium whitespace-nowrap text-gray-900">{items.find(item => item.value === value || (Array.isArray(item.value) && typeof value === "string" && item.value.includes(value)))?.name ?? "Select option..."}</P>
</Button>
<Dropdown style="max-height: 20rem; overflow:auto;" id={dropdownKey} bind:open={dropdownOpen} {placement}>
	{#each items as option (option.value)}
		<DropdownItem data-action-name={`${dropdownKey}-option`} data-action-title={option.name} value={option.value} on:click={handleClick}>
			{option.name}
		</DropdownItem>
	{/each}
</Dropdown>
